import React from "react";
import Layout from "components/layout";
import SEO from "components/seo";
var NotFoundPage = function NotFoundPage(_ref) {
    var data = _ref.data, location = _ref.location;
    var siteTitle = data.site.siteMetadata.title;
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location,
        title: siteTitle
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: "404: Not Found"
    }), /*#__PURE__*/ React.createElement("h1", null, "Not Found"), /*#__PURE__*/ React.createElement("p", null, "You just hit a route that doesn't exist... the sadness."));
};
export default NotFoundPage;
export var pageQuery = "2513322031";
